import ListView from "../view/list.js";
import ButtonView from "../view/button.js";

import SelectedModel from "../model/selected.js";

import {
  defaultModelData,
  ActionType,
  ANIMATION_DURATION
} from "../const.js";

import {
  createElement,
  removeElement,
  render,
  replace,
  RenderPosition
} from "../../../render/render.js";

import {
  AnimationClass
} from "../../../animation/const.js";

export default class Selected {
  constructor(
      wrapperView,
      animation,
      changeFilter,
      filterWrapperPresenter
  ) {
    this._model = null;

    this._listView = null;
    this._buttonsViews = [];

    this._wrapperView = wrapperView;
    this._animation = animation;
    this._changeFilter = changeFilter;
    this._filterWrapperPresenter = filterWrapperPresenter;

    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
    this._handleButtonClick = this._handleButtonClick.bind(this);
  }

  init() {
    this._model = new SelectedModel(defaultModelData);
    this._model.addObserver(this._handleChangeData);
    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);

    const selectedElement = this._wrapperView.getSelectedElement();

    this._initView(selectedElement);
  }

  _initView(element) {
    if (!element) {
      return;
    }

    this._model.changeData(Object.assign(
        this._model.getData(),
        {
          rendered: true
        }
    ), ActionType.INIT, {
      element
    });
  }

  _updateView(element) {
    replace(element, this._listView.getElement());
    this._listView.updateElement(element);

    this._animation.fadeIn(
        this._listView.getElement(),
        ANIMATION_DURATION,
        null,
        AnimationClass.SHOW_FLEX
    );

    this._setButtonsHandlers();
  }

  _setButtonsHandlers() {
    this._buttonsViews = [];
    const buttons = this._listView.getButtonsElements();

    if (buttons.length === 0) {
      return;
    }

    Array.from(buttons)
      .forEach((element, index) => {
        const view = new ButtonView(element, index);
        view.setClickHandler(this._handleButtonClick);
        this._buttonsViews.push(view);
      });
  }

  _processInit(payload) {
    const element = payload.element;

    if (!element) {
      return;
    }

    this._listView = new ListView(element);

    this._animation.fadeIn(
        this._listView.getElement(),
        ANIMATION_DURATION,
        null,
        AnimationClass.SHOW_FLEX
    );

    this._setButtonsHandlers();
  }

  _processDestroy() {
    this._animation.fadeOut(
        this._listView.getElement(),
        ANIMATION_DURATION,
        () => {
          removeElement(this._listView.getElement());

          this._listView = null;
          this._buttonsViews = [];
        }
    );
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.INIT:
        this._processInit(payload);
        break;
      case ActionType.DESTROY:
        this._processDestroy();
        break;
    }
  }

  _handleChangeFilterLoad(data) {
    if (!data.selected) {
      if (this._model.getData().rendered === true) {
        this._model.changeData(Object.assign(
            this._model.getData(),
            {
              rendered: false
            }
        ), ActionType.DESTROY, {
          element
        });
      }

      return;
    }

    const element = createElement(data.selected);

    if (this._model.getData().rendered === true) {
      this._updateView(element);
      return;
    }

    render(this._wrapperView.getActionsElement(), element, RenderPosition.AFTEREND);
    this._initView(element);
  }

  _handleButtonClick(index) {
    const view = this._buttonsViews[index];

    if (!view) {
      return;
    }

    this._filterWrapperPresenter.disableValue(
        view.getProperty(),
        view.getValue()
    );
    this._changeFilter.updateProductsData();
  }
}
